export class DataQualityDashboard {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sections",
            "baseName": "sections",
            "type": "Array<DataQualityDashboardSection>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityDashboard.attributeTypeMap;
    }
    constructor() {
    }
}
